var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceTag = function SvgPlaceTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.35 15.357 8 15.7l-.35-.343c-3.42-3.352-5.15-6.58-5.15-9.69C2.5 2.805 4.97.5 8 .5s5.5 2.305 5.5 5.167c0 3.11-1.73 6.338-5.15 9.69m4.15-9.69C12.5 3.373 10.493 1.5 8 1.5S3.5 3.373 3.5 5.667c0 2.698 1.489 5.576 4.5 8.627 3.011-3.051 4.5-5.929 4.5-8.627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgPlaceTag;